import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PageHero = ({
  eyebrow,
  title,
  description,
  primaryCta,
  secondaryCta,
  testId,
}) => {
  return (
    <section className="border-b border-slate-200 bg-white" data-testid={testId}>
      <div className="mx-auto w-full max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="max-w-4xl space-y-4">
          {eyebrow ? (
            <p
              className="inline-block rounded-full bg-slate-100 px-4 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-slate-600"
              data-testid={`${testId}-eyebrow`}
            >
              {eyebrow}
            </p>
          ) : null}
          <h1
            className="text-4xl font-semibold text-slate-900 sm:text-5xl lg:text-6xl"
            data-testid={`${testId}-title`}
          >
            {title}
          </h1>
          <p
            className="max-w-3xl text-base leading-relaxed text-slate-600 md:text-lg"
            data-testid={`${testId}-description`}
          >
            {description}
          </p>
          {(primaryCta || secondaryCta) && (
            <div className="flex flex-wrap gap-3 pt-3" data-testid={`${testId}-cta-group`}>
              {primaryCta ? (
                <Button
                  asChild
                  className="rounded-full bg-orange-500 px-6 py-5 text-sm font-semibold text-white hover:bg-orange-600"
                  data-testid={`${testId}-primary-cta`}
                >
                  <Link to={primaryCta.path} data-testid={`${testId}-primary-link`}>
                    {primaryCta.label}
                  </Link>
                </Button>
              ) : null}
              {secondaryCta ? (
                <Button
                  asChild
                  variant="outline"
                  className="rounded-full border-slate-300 px-6 py-5 text-sm font-semibold text-slate-700"
                  data-testid={`${testId}-secondary-cta`}
                >
                  <Link to={secondaryCta.path} data-testid={`${testId}-secondary-link`}>
                    {secondaryCta.label}
                  </Link>
                </Button>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;